import { toast } from "sonner";

/**
 * Parses a Supabase RPC error and shows a toast with the stable error code.
 * Returns the error code string for further handling.
 */
export function handleRpcError(error: unknown): string {
  const err = error as { code?: string; message?: string; details?: string };
  const message = err?.message ?? "Unknown error";

  // Extract stable error code from 23514 messages
  // Format is typically "ERROR: CODE_HERE" or just "CODE_HERE"
  const code = err?.code === "23514" || err?.code === "42501"
    ? message.replace(/^.*?:\s*/, "").split(/\s/)[0]
    : message;

  toast.error(code, { description: message !== code ? message : undefined });
  return code;
}
